/**
 * labTraceabilityPermissions.ts — Issue #399.
 *
 * Permission helpers for the lab traceability read-model surface. Mirrors the
 * backend gate in apps/api/src/modules/lab-traceability/lab-traceability.controller.ts.
 *
 * Permission strings are `<resource>:<action>`; wildcards `*:*`,
 * `lab.traceability:*` and `*:<action>` resolve via the shared
 * `hasPermission` helper.
 */

import { hasPermission } from './crmPermissions';

export const LAB_TRACEABILITY_PERMISSIONS = {
  READ: 'lab.traceability:read',
  READ_FULL: 'lab.traceability:read_full',
  GENERATE: 'lab.traceability:generate',
  REVIEW: 'lab.traceability:review',
  ARCHIVE: 'lab.traceability:archive',
  EXPORT: 'lab.traceability:export',
  REVEAL: 'lab.traceability:reveal',
  MANAGE: 'lab.traceability:manage',
} as const;

export function canSeeLabTraceability(granted: readonly string[]): boolean {
  // Mirrors the backend list gate: caller needs both :read and :read_full.
  // Without :read_full the controller returns an empty page anyway, but the
  // menu / page would be useless to the caller, so we hide it.
  return (
    hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.READ) &&
    hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.READ_FULL)
  );
}

export function canGenerateLabTraceability(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.GENERATE);
}

export function canReviewLabTraceability(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.REVIEW);
}

export function canArchiveLabTraceability(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.ARCHIVE);
}

export function canExportLabTraceability(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.EXPORT);
}

export function canRevealLabTraceability(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, LAB_TRACEABILITY_PERMISSIONS.REVEAL);
}
